import { isNonNullable } from "@/modules/utils/predicate";
import { type ToyCoupon, type ToyCouponStatus } from "./type";
import { parse } from "date-fns";

export const getToyCouponStatus = (toyCoupon: ToyCoupon): ToyCouponStatus => {
  if (isNonNullable(toyCoupon.usedAt)) {
    return "used";
  }

  if (
    isNonNullable(toyCoupon.expiresAt) &&
    parse(toyCoupon.expiresAt, "yyyy-MM-dd HH:mm:ss", new Date()) <= new Date()
  ) {
    return "expired";
  }

  return "available";
};
